import { render, staticRenderFns } from "./GExamCreateQuestionSettingCompetencySelection.vue?vue&type=template&id=a5936eb2&"
import script from "./GExamCreateQuestionSettingCompetencySelection.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateQuestionSettingCompetencySelection.vue?vue&type=script&lang=ts&"
import style0 from "./GExamCreateQuestionSettingCompetencySelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports